import Axios from "axios";
import { getAuth } from "firebase/auth";

export const axios = Axios.create({
  baseURL: process.env.REACT_APP_API,
});

const refreshToken = async () => {
  const auth = getAuth();
  const currentUser = auth.currentUser;
  if (currentUser) {
    return await currentUser.getIdToken(true);
  }
  return null;
};

axios.interceptors.request.use(
  (req) => {
    const token = localStorage.getItem("token");
    if (token) {
      req.headers = {
        ...req.headers,
        authorization: "Bearer " + token,
      };
    }
    return req;
  },
  (error) => {
    return Promise.reject(error);
  },
);

axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (
      error.response &&
      error.response.status === 401 &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;
      const newToken = await refreshToken();
      if (newToken) {
        localStorage.setItem("token", newToken);
        axios.defaults.headers["authorization"] = `Bearer ${newToken}`;
        originalRequest.headers["authorization"] = `Bearer ${newToken}`;
        return axios(originalRequest);
      }
    }
    return Promise.reject(error);
  },
);
